import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hidden bg-white z-50 w-full h-[80px] shadow-md sm:grid place-items-center" }
const _hoisted_2 = { class: "w-11/12 max-w-screen-xl 4xl:max-w-screen-3xl flex gap-10 items-center content-between mx-auto" }
const _hoisted_3 = { class: "flex items-end gap-4" }
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-darkGray-1 font-semibold px-4 py-1"
}
const _hoisted_5 = { class: "flex row-wrap gap-8 items-center ml-auto" }
const _hoisted_6 = { class: "grid w-full h-full sm:hidden" }
const _hoisted_7 = { class: "grid w-full h-[60px] py-4 px-2 text-darkGray-1 place-content-center fixed z-50 bg-white top-0 left-0 shadow-md" }
const _hoisted_8 = {
  key: 0,
  class: "fixed top-[60px] left-0 w-full h-full bg-white z-50 border border-t-blue-3 shadow-md"
}
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "text-xl font-semibold" }

import { ref } from "vue";

interface ListItem {
  name: string;
  link: string;
  icon: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    listItems: {}
  },
  setup(__props: any) {

const host = window.location.host;
const parts = host.split(".");
const subdomain = parts[0];

const isDevOrStaging =
  subdomain.includes("jobb-dev") || subdomain.includes("jobb-staging");

const props = __props;

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: { name: 'publicPositions' } }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: "/images/logo.svg",
                alt: "logo",
                class: "h-10"
              }, null, -1)
            ]))]),
            _: 1
          }),
          (_unref(isDevOrStaging))
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " OBS! Ej riktig data, endast för utveckling och testning. "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.listItems, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.name,
              to: item.link,
              class: "flex place-content-center hover:text-blue-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128)),
          _createVNode(_component_router_link, {
            to: { name: 'publicPositions' },
            class: "flex place-content-center"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "relative inline-flex items-center rounded-md border border-transparent bg-gradient-to-b from-orange-1 to-orange-2 px-4 py-2 font-medium text-white shadow-sm hover:from-orange-2 hover:to-orange-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" }, " Sök jobb ", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("nav", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "m-auto",
          to: { name: 'publicPositions' }
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: "/images/logo.svg",
              alt: "logo",
              class: "h-8"
            }, null, -1)
          ]))]),
          _: 1
        }),
        (!isMenuOpen.value)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "absolute top-1/2 right-4 transform -translate-y-1/2 fas fa-bars text-blue-1 text-2xl",
              onClick: toggleMenu
            }))
          : (_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "absolute top-1/2 right-4 transform -translate-y-1/2 fas fa-times text-blue-1 text-2xl",
              onClick: toggleMenu
            }))
      ]),
      (isMenuOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.listItems, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.name,
                  to: item.link,
                  onClick: toggleMenu,
                  class: "py-6 px-10 border-b border-b-blue-3 flex place-content-between items-center hover:text-blue-1 focused:text-blue-1"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(item.icon)
                    }, null, 2),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(item.name), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa-solid fa-arrow-right-long -rotate-45" }, null, -1))
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              _createVNode(_component_router_link, {
                to: { name: 'publicPositions' },
                class: "p-8 flex place-content-center",
                onClick: toggleMenu
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("span", { class: "relative inline-flex items-center rounded-md border border-transparent bg-blue-1 px-4 py-2 text-lg font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" }, " Sök jobb ", -1)
                ]))]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})